// src/utils/dataUtils.js
export function chunkArray(array, size) {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
    }
    return result;
}


export function cleanProperties(obj) {
    const cleaned = {};
    Object.entries(obj).forEach(([key, value]) => {
        if (
            value !== '__NONE__' &&
            value !== '' &&
            value !== null &&
            value !== undefined
        ) {
            cleaned[key] = value;
        }
    });
    return cleaned;
}

export function prepareData(features) {
    return features.map(f => {
        const { ['@relations']: _, ...p } = f.properties || {};
        return {
            id: f.id || crypto.randomUUID(),
            description: f.id,
            metadata: {
                p: cleanProperties(p)  // ✅ PULISCI QUI
            }
        };
    });
}
export async function sendFeaturesInChunks(loadAllData, nameRegion, features, setProgress, setIsUploading) {
    const processed = prepareData(features);
    const chunks = chunkArray(processed, 10);

    setIsUploading(true);

    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL_NODE}/api/recreate-index`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ loadAllData, nameRegion })
        });

        if (!res.ok) {
            const text = await res.text();
            console.error('❌ Errore server:', text);
            setIsUploading(false);
            return;
        }

        const data = await res.json();

        if (!loadAllData && data.toReload === 0) {
            setProgress(100);
            setIsUploading(false);
            return;
        }

        for (let i = 0; i < chunks.length; i++) {
            const chunk = chunks[i];
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL_NODE}/api/insert-features`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ features: chunk }),
                });

                if (!res.ok) {
                    const text = await res.text();
                    console.error('❌ Errore server:', text);
                    break;
                }

                console.log(`✅ Chunk ${i + 1}/${chunks.length} inserito`);
                const progressValue = Math.round(((i + 1) / chunks.length) * 100);
                setProgress(progressValue);

            } catch (err) {
                console.error('❌ Errore fetch:', err);
                break;
            }
        }
    } catch (err) {
        console.error('❌ Errore generale:', err);
    } finally {
        setIsUploading(false);
    }
}

export function getMinSeverity(alertControls) {
    if (!alertControls.typeFilters.includes('avalanche'))
        return 10
    if (!alertControls.severityFilters.length)
        return 4;
    if (alertControls.severityFilters.includes('low'))
        return 1;
    if (alertControls.severityFilters.includes('medium'))
        return 2;
    if (alertControls.severityFilters.includes('high'))
        return 3;
    if (alertControls.severityFilters.includes('extreme'))
        return 4;
    return 1;
}